import {FORMS_TEMPLATE_IDS} from '../../constants';
import {FormViewer} from '@wix/form-viewer/widget';
import React, {useEffect} from 'react';
import {useControllerProps} from '../../Widget/ControllerContext';
import {useICUI18n} from '../../Hooks/useICUI18n';
import {usePanorama} from '@wix/yoshi-flow-editor';
import {FormOverrides} from '@wix/form-viewer';
import {FormProps, getCountryCode} from '../form.utils';
import {usePaymentsApi} from '../../../../common/components/WithPaymentsApi/WithPaymentsApi';
import {BillingFormOverrides} from '../../../../types/checkoutApp.types';

export type BillingFormProps = FormProps & {overrides: BillingFormOverrides};

const BillingFormInternal = ({
  formRef,
  formValues,
  setFormValues,
  formErrors,
  setFormErrors,
  overrides,
}: BillingFormProps) => {
  const {
    checkoutStore: {reportCheckoutBillingAddressPresentedToVisitor},
  } = useControllerProps();

  const i18n = useICUI18n();
  const panorama = usePanorama();
  const {activePaymentId} = usePaymentsApi();
  const country = getCountryCode(formValues);

  useEffect(
    () => {
      reportCheckoutBillingAddressPresentedToVisitor({overrides});
    },
    /* eslint-disable react-hooks/exhaustive-deps */ [country, activePaymentId]
  );

  return (
    <FormViewer
      i18n={i18n}
      panorama={panorama}
      ref={formRef}
      overrides={overrides as FormOverrides}
      formId={FORMS_TEMPLATE_IDS.BILLING}
      values={formValues}
      errors={formErrors}
      onChange={setFormValues}
      onValidate={setFormErrors}
    />
  );
};

export const BillingForm = React.memo(BillingFormInternal);
